import IconNameEnum from "constants/IconNameEnum";
import PermissionEnum from "constants/PermissionEnum";
import IAction from "models/IAction";
import IStore from "models/IStore";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { connect, DispatchProp } from "react-redux";
import { selectRequesting } from "selectors/requesting/RequestingSelector";
import CercaAction from "stores/ricerca/CercaAction";
import CercaPreventiviTabellaModel from "stores/ricerca/models/CercaPreventiviTabellaModel";
import UserPermissionModel from "stores/utente/models/UserPermissionModel";
import FormatUtility from "utilities/FormatUtility";
import BaseModal from "views/components/base-content/BaseModal";
import BaseButton from "views/components/base-form/BaseButton";
import LoadingIndicator from "views/components/loading-indicator/LoadingIndicator";

interface IProps {
    handlePopup: () => void;
    open: boolean;
}

interface IState {}

interface IStateToProps {
    readonly dettaglioPreventivo?: CercaPreventiviTabellaModel;
    readonly isRequesting: boolean;
    readonly userPermissions: UserPermissionModel;
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    dettaglioPreventivo: state.cerca.cercaDettalgioPreventivoModel,
    isRequesting: selectRequesting(state, [CercaAction.REQUEST_DETTAGLIO_PREVENTIVO_BY_ID_FINISHED]),
    userPermissions: state.utente.responsePermissions,
});

class CercaPreventivoDettaglio extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>, state: IState) {
        super(props);
    }

    public getModalForm = () => {
        const { dettaglioPreventivo, userPermissions } = this.props;

        return (
            <>
                {this.props.isRequesting ? (
                    <LoadingIndicator className="mb-3" isActive={true} />
                ) : (
                    <>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>N° preventivo</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioPreventivo?.idEstimateRequest ?? "-"}
                                </span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>N° pratica:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.idPractice ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Nome:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.firstName ?? "-"}</span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Cognome:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.lastName ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Denominazione simulazione:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.simulationName ?? "-"}</span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>N° Simulazione:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.idSimulation ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Agente:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.agent ?? "-"}</span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Canale:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold"> {dettaglioPreventivo?.channel ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Segmento:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.segment ?? "-"} </span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Tipo richiesta:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.requestType ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>ATC:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.atc ?? "-"}</span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Tipo cliente:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.customerType ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Rata:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioPreventivo?.installment
                                        ? FormatUtility.currency(dettaglioPreventivo.installment)
                                        : "-"}
                                </span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Durata (mesi):</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.duration ?? "-"} mesi</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Importo:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    <span className="font-weight-bold">
                                        {dettaglioPreventivo?.amount !== undefined
                                            ? FormatUtility.currency(dettaglioPreventivo.amount)
                                            : "-"}
                                    </span>
                                </span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Montante:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioPreventivo?.futureValue
                                        ? FormatUtility.currency(dettaglioPreventivo.futureValue)
                                        : "-"}
                                </span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>RV:</span>
                            </Col>
                            <Col md={8} lg={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.rv ?? "-"}</span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>RC:</span>
                            </Col>
                            <Col md={8} lg={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.rc ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Provvigioni:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioPreventivo?.commissions !== null
                                        ? FormatUtility.currency(dettaglioPreventivo?.commissions || 0)
                                        : "-"}
                                </span>{" "}
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Saldo:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioPreventivo?.balance !== undefined
                                        ? FormatUtility.currency(dettaglioPreventivo?.balance)
                                        : "-"}
                                </span>{" "}
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Nome prodotto:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioPreventivo?.product ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left">
                                <span>TAN:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioPreventivo?.tan !== undefined
                                        ? FormatUtility.percentage(dettaglioPreventivo?.tan, 4)
                                        : "-"}
                                </span>
                            </Col>
                            {userPermissions.permissions.find((item) =>
                                item.includes(PermissionEnum.CQS_Prev_VediIRR)
                            ) && (
                                <>
                                    <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                        <span>IRR:</span>
                                    </Col>
                                    <Col md={8} lg={6} xl={3}>
                                        <span className="font-weight-bold">
                                            {dettaglioPreventivo?.irr !== undefined
                                                ? FormatUtility.percentage(dettaglioPreventivo?.irr, 2)
                                                : "-"}
                                        </span>
                                    </Col>
                                </>
                            )}
                        </Row>
                        <Row>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left">
                                <span>TAEG:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioPreventivo?.taeg !== undefined
                                        ? FormatUtility.percentage(dettaglioPreventivo?.taeg)
                                        : "-"}
                                </span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>TEG:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioPreventivo?.teg !== undefined
                                        ? FormatUtility.percentage(dettaglioPreventivo?.teg)
                                        : "-"}
                                </span>
                            </Col>
                        </Row>
                    </>
                )}
            </>
        );
    };

    public render(): JSX.Element {
        const { open, handlePopup } = this.props;
        const modalForm = this.getModalForm();

        return (
            <BaseModal
                show={open}
                onHideHandler={handlePopup}
                closeOnOutClick={false}
                centered={true}
                title="Dettaglio preventivo"
                bodyLeft={true}
                body={<>{modalForm}</>}
                size="xl"
                footer={
                    <>
                        <BaseButton
                            type="button"
                            color="grey"
                            label={"Chiudi"}
                            onClickHandler={handlePopup}
                            icon={IconNameEnum.Ko}
                        />
                    </>
                }
            />
        );
    }
}

export { CercaPreventivoDettaglio as Unconnected };
export default connect(mapStateToProps)(CercaPreventivoDettaglio);
